export default [
    {
        organization: "Western AI",
        site: "https://www.westernuai.com/",
        img: "img/organizations_logos/wai.png",
        location: "London, Ontario",
        position: "Project Manager",
        duration: "October 2019 &#8211 April 2020",
        description: [
            'Project Manager for AI project pertaining to medical imaging',
            'Worked with team to set deadlines and formulate checkpoints to achieve goal',
            'Developed educational presentations and demos to educate team',
        ],
        display: true,
    },
    {
        organization: "Western Management Club",
        site: "https://www.westernmanagementclub.com/",
        img: "img/organizations_logos/wmc.png",
        location: "London, Ontario",
        position: "Management Consultant",
        duration: "November 2019 &#8211 April 2020",
        description: [
            'Worked in a team to provide pro bono consulting services for a local business in London, Ontario',
            'Followed a strict timeline to produce deliverables as per client specifications',
        ],
        display: true,
    },
    {
        organization: "Western Management Club",
        site: "https://www.westernmanagementclub.com/",
        img: "img/organizations_logos/wmc.png",
        location: "London, Ontario",
        position: "Management Consultant",
        duration: "October 2018 &#8211 April 2019",
        description: [
            'Worked in a team to provide pro bono consulting services for a local business in London, Ontario',
            'Followed a strict timeline to produce deliverables as per client specifications',
        ],
        display: true,
    }
]